// extracted by mini-css-extract-plugin
export default {"page":"CaptchaPage_page__v6Msl"};